module.exports = __webpack_public_path__ + "media/images/icon/icons8-line-48-ec150dd2adde1fa86ad534c8f0cfadb5.png";